<template>
  <div>
    <h1 class="h3">You’re one step closer to becoming a Member!</h1>
    <p class="label mb-30">Applications closing soon</p>
    <p class="label"><sup>*</sup> required</p>
    <fieldset class="row">
      <legend class="col-sm-12">Tell us about yourself</legend>
      <b-col md="4">
        <ValidationProvider mode="eager" rules="required" name="first-name" v-slot="{ errors }" slim>
          <b-form-group id="first-name-group" label="First Name*" label-for="first-name" role="alert">
            <b-form-input
              id="first-name"
              v-model="first_name"
              :aria-describedby="errors.length ? 'first-name-error' : null"
              class="btn-double-outline btn-double-outline--normal"
              :state="errors[0] ? false : null"
              v-remove-aria-required
            ></b-form-input>
            <b-form-invalid-feedback id="first-name-error" v-if="errors.length">
              Error: First Name is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="4">
        <ValidationProvider mode="eager" rules="required" name="last-name" v-slot="{ errors }" slim>
          <b-form-group id="last-name-group" label="Last Name*" label-for="last-name" role="alert">
            <b-form-input
              id="last-name"
              v-model="last_name"
              :aria-describedby="errors.length ? 'last-name-error' : null"
              class="btn-double-outline btn-double-outline--normal"
              :state="errors[0] ? false : null"
              v-remove-aria-required
            ></b-form-input>
            <b-form-invalid-feedback id="last-name-error" v-if="errors.length">
              Error: Last Name is required
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="4">
        <ValidationProvider mode="eager"
          rules="required|email|noEuroEmail"
          name="email" v-slot="{ errors }" slim>
         <b-form-group id="email-group" label="Email*" label-for="email" role="alert">
          <b-form-input
            id="email"
            v-model="email"
            type="email"
            :aria-describedby="errors.length ? 'email-error' : null"
            class="btn-double-outline btn-double-outline--normal"
            :state="errors[0] ? false : null"
            v-remove-aria-required
          ></b-form-input>
          <b-form-invalid-feedback id="email-error" v-if="errors.length">
            Error: Email must be valid. Please provide a valid email (e.g. email@address.com)
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="does_user_exist" force-show>
            This email has been used to sign up.
          </b-form-invalid-feedback>
        </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col sm="12">
        <div class="form-group form-group--bg-color">
          <b-form-checkbox
            id="opt-in"
            v-model="opt_in"
            name="opt-in"
            :value="true"
            :unchecked-value="false"
            class="custom-checkbox--reverse-outline"
          >
            Would you like to sign up to receive marketing communications from Nitto and Driving Line? By checking this box, you agree to Nitto Tire’s <a aria-label="Terms & Conditions (opens in a new window)" href="https://www.nittotire.com/terms/" target="_blank">Terms & Conditions</a> & that you have read and understood the <a aria-label="Privacy Policy (opens in a new window)" href="https://www.nittotire.com/privacy/" target="_blank">Privacy Policy</a>
            <p><a aria-label="Information for California Residents (opens in a new window)" class="ca-privacy-link" href="https://www.nittotire.com/privacy/#california-residents" target="_blank">Information for California Residents</a></p>
          </b-form-checkbox>
        </div>
      </b-col>
    </fieldset>
  </div>
</template>

<script>

export default {
  name: 'PersonalInfo',
  props: {
    does_user_exist: { type: Boolean, default: false },
  },
  watch: {
    first_name(newVal, oldVal) {
      if (newVal === oldVal) { return; }
      this.validateStep();
    },
    last_name(newVal, oldVal) {
      if (newVal === oldVal) { return; }
      this.validateStep();
    },
    email(newVal, oldVal) {
      if (newVal === oldVal) { return; }
      this.validateStep();
    },
  },
  computed: {
    first_name: {
      get() {
        return this.$store.state.FirstName;
      },
      set(value) {
        this.$store.dispatch('firstName', value);
      },
    },
    last_name: {
      get() {
        return this.$store.state.LastName;
      },
      set(value) {
        this.$store.dispatch('lastName', value);
      },
    },
    email: {
      get() {
        return this.$store.state.Email;
      },
      set(value) {
        this.$store.dispatch('email', value);
      },
    },
    opt_in: {
      get() {
        return this.$store.state.NewsletterOptIn;
      },
      set(value) {
        this.$store.dispatch('newsletterOptIn', value);
      },
    },
  },
  methods: {
    validateStep() {
      this.$emit('onValidate', null);
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  max-width: 380px;
  margin-bottom: 16px;
}

h3 {
  margin-bottom: 32px;
}

a {
  color: white;
}

.mb-30 {
  margin-bottom: 30px;
}

.ca-privacy-link {
  font-size: 14px;
  text-decoration: underline;
  margin-top: 10px;
  display: inline-block;
}
legend {
  @extend %roboto-font-regular;
  font-size: 18px;
  margin-bottom: 1rem;
}
a {
  text-decoration: underline;
}

.form-group {
  &--bg-color {
    background-color: rgba(0, 0, 0, 0.75);
    padding: 15px 15px 1px;
    border-radius: 5px;
  }
}
</style>
